import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Aside from '../components/Aside';
import { getRoutes } from '../constants/Routes';
import useAuth from '../hooks/useAuth';
import Header from '../components/Header';

const PrivateRoute = () => {
  const { token } = useAuth();
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);

  if (!token) {
    return <Navigate to={getRoutes().login.route()} />;
  }

  return (
    <div className="Layout">
      <div className="Layout__Header">
        <Header
          isSideBarOpen={isSideBarOpen}
          onSiderBarToggle={() => setIsSideBarOpen(!isSideBarOpen)}
        />
      </div>
      <div className="Layout__Container">
        <div className="Layout__Container__Aside">
          <Aside
            isSideBarOpen={isSideBarOpen}
            onSiderBarToggle={() => setIsSideBarOpen(!isSideBarOpen)}
            isLabeled={false}
          />
        </div>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PrivateRoute;
